<span mat-dialog-title class="font-title-contrast">Es ist ein Fehler aufgetreten</span>
<mat-dialog-content>
    <span class="font-header-contrast"><p>Das sollte nicht passieren. Es ist ein Fehler aufgetreten: <br>
  {{errorMessage}}<br><br></p></span>
  <span class="font-text-contrast">{{errorText}}<br><br></span>
  <span class="errorMessage">Bitte melden Sie zur Behebung den Fehler der BAT-Administration.<br>
  <br>
  Mit freundlichen Grüßen<br>
  HCH HafenCity<br><br></span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Schließen</button>
</mat-dialog-actions>
